module.exports = __webpack_public_path__ + "img/zenfone6_black.11c76480.png";